import React from "react";
import RouterLink from "next/link";

import {
	Link,
	LinkVariant,
	IconCogStroke,
	IconSwitch,
	ButtonVariant,
	Skeleton,
	Accordion,
} from "@jasperlabs/jux-next";

import AddInvestingEntityButton from "./AddInvestingEntityButton";

import {
	InvestingEntityAvatar,
	InvestingEntityTag,
} from "./InvestingEntityLabel";

import { useInvestingEntitiesDropdownQueryQuery } from "./InvestingEntitiesDropdownMenu.generated";

const InvestingEntitiesMobileDropdownMenu = () => {
	const { data, loading } = useInvestingEntitiesDropdownQueryQuery();

	if (loading) {
		return (
			<div className="flex p-4 gap-4 h-[132px] items-center">
				<Skeleton.Circle className="w-10 h-10" />
				<div className="grid gap-2">
					<Skeleton.TextBody className="w-32 h-2" />
					<Skeleton.TextBody className="w-16 h-2" />
				</div>
			</div>
		);
	}

	const investingEntity = data?.account?.activeInvestingEntity;

	if (!investingEntity) {
		return (
			<div className="w-full p-4">
				<AddInvestingEntityButton
					variant={ButtonVariant.Secondary}
					className="w-full"
				/>
			</div>
		);
	}

	return (
		<div className="p-4 grid gap-4">
			<span className="text-overline-sm text-neutral-300">Investing as</span>

			<Accordion type="single" collapsible>
				<Accordion.Item value="1">
					<Accordion.Trigger className="py-0">
						<div className="flex flex-col items-start gap-2">
							<div className="flex gap-3">
								<InvestingEntityAvatar
									investingEntity={investingEntity}
									variant="primary"
								/>
								<span className="text-subheading-sm max-w-[150px] justify-self-start truncate text-black">
									{investingEntity.name}
								</span>
							</div>

							<div>
								<InvestingEntityTag investingEntity={investingEntity} />
							</div>
						</div>
					</Accordion.Trigger>

					<Accordion.Content className="pb-0">
						<ul className="grid gap-4 pt-4">
							<li>
								<Link
									as={RouterLink}
									icon={<IconCogStroke className="text-[18px] text-black" />}
									variant={LinkVariant.Black}
									className="text-body-default flex w-full text-black"
									href="/investing-entities/details"
								>
									Update Entity Settings
								</Link>
							</li>
							<li>
								<Link
									as={RouterLink}
									icon={<IconSwitch className="text-[18px] text-black" />}
									variant={LinkVariant.Black}
									className="text-body-default flex w-full text-black"
									href="/switch-investing-entities"
								>
									Manage Investing Entities
								</Link>
							</li>
						</ul>
					</Accordion.Content>
				</Accordion.Item>
			</Accordion>
		</div>
	);
};

export default InvestingEntitiesMobileDropdownMenu;
